
// Pages
export const HOME_PAGE_URL = '/';
export const ABOUT_PAGE_URL = '/about-me';
export const CLIPS_FANSITES_PAGE_URL = '/clips-fansites';
export const LINKS_PAGE_URL = '/links';
export const SERVICES_PAGE_URL = '/services';
export const QUESTIONNAIRE_PAGE_URL = '/questionnaire';
export const GALLERY_PAGE_URL = '/gallery';
export const CONTACT_PAGE_URL = '/contact';
export const ADMIN_CONTACT_FORM_PAGE_URL = '/admin/contact-forms';
export const TESTIMONIALS_PAGE_URL = '/testimonials';
export const POLICIES_PAGE_URL = '/user-agreements';
export const MAINTENANCE_PAGE_URL = '/down-for-maintenance';
export const ERROR_404_PAGE_URL = '*';

// User pages
export const LOGIN_PAGE_URL = '/login';
export const RESET_PASS_PAGE_URL = '/reset-password';